import { render, staticRenderFns } from "./RocketChat.vue?vue&type=template&id=55134243&"
import script from "./RocketChat.vue?vue&type=script&lang=ts&"
export * from "./RocketChat.vue?vue&type=script&lang=ts&"
import style0 from "./RocketChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports